import { useContext } from 'react';
import { ErrorContext } from './ErrorProvider';
export var useErrorBoundary = function () {
    return useContext(ErrorContext);
};
//# sourceMappingURL=useErrorBoundary.js.map